module.exports = __webpack_public_path__ + "static/img/1.e929913.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting790/images/1.png
// module id = LWYY
// module chunks = 4